/*
  Parallax vertical para los slides que lo activen.

  Desplaza la imagen a una fraccion del scroll con translate3d, que el navegador
  compone en GPU. No se usa background-attachment: fixed porque iOS no lo
  soporta.

  El recorrido se calcula sobre el margen real de la imagen (lo que mide de mas
  respecto a su contenedor) y sobre el progreso de la seccion por la pantalla,
  normalizado entre 0 y 1. Es deliberado: la formula ingenua `rect.top * factor`
  solo funciona si la seccion arranca pegada al borde superior. Con un header y
  una barra de anuncios encima, rect.top empieza positivo y la imagen se
  desplazaria hacia abajo dejando un hueco.

  Con este calculo la imagen va de "borde superior alineado" a "borde inferior
  alineado" como maximo, asi que no puede descubrir el fondo en ningun extremo.
*/
(function () {
  if (window.__slideParallaxInit) return;
  window.__slideParallaxInit = true;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mover() {
    var boxes = document.querySelectorAll('.slide-parallax');
    if (!boxes.length) return;

    var vh = window.innerHeight;

    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var rect = box.getBoundingClientRect();

      /* Fuera de pantalla: no hace falta calcular ni pintar. */
      if (rect.bottom < 0 || rect.top > vh) continue;

      /* Solo las imagenes, no el envoltorio .lazy-image: si se transforman
         ambos, los desplazamientos se suman y se consume el doble de margen. */
      var capas = box.querySelectorAll('img, video');

      var fuerza = parseFloat(box.getAttribute('data-parallax-strength'));
      if (isNaN(fuerza)) fuerza = 0.6;

      /* 0 cuando la seccion asoma por abajo, 1 cuando termina de salir por
         arriba. Acotado para que fuera de ese tramo no siga acumulando. */
      var avance = (vh - rect.top) / (vh + rect.height);
      if (avance < 0) avance = 0;
      if (avance > 1) avance = 1;

      for (var j = 0; j < capas.length; j++) {
        var capa = capas[j];

        if (quieto.matches) {
          capa.style.transform = 'none';
          continue;
        }

        /* Margen disponible en pixeles reales. Si la imagen no es mas alta que
           su caja no hay recorrido posible y moverla solo abriria un hueco. */
        var margen = capa.offsetHeight - box.offsetHeight;
        if (margen <= 0) {
          capa.style.transform = 'none';
          continue;
        }

        capa.style.transform =
          'translate3d(0,' + -(margen * avance * fuerza) + 'px,0)';
      }
    }
  }

  /* passive: true — el handler no llama preventDefault, y decirlo evita que el
     navegador retrase el scroll esperando a ver si lo hace. */
  window.addEventListener('scroll', mover, { passive: true });
  window.addEventListener('resize', mover, { passive: true });
  document.addEventListener('DOMContentLoaded', mover);

  /* El editor de temas reemplaza el HTML de la seccion al editarla. */
  document.addEventListener('shopify:section:load', mover);
  document.addEventListener('shopify:section:select', mover);

  mover();
})();
